import { api } from '../index';

const prefix = '/api/basic_info/retail_setting/media';

export function apiUploadMedia(category, files) {
	const form = new FormData();
	form.append('category', category);
	for (const f of files) {
		form.append('files', f);
	}
	return api.post(prefix + '/upload', form, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});
}

export function apiSaveMedia(category, items) {
	return api.put(prefix + '/' + category, { items });
}

export function apiGetMedia(category) {
	return api.get(prefix + '/' + category);
}

const optionsPrefix = '/api/basic_info/retail_setting/options';

export function apiGetOptions() {
	return api.get(optionsPrefix);
}

export function apiSaveOptions(payload) {
	return api.put(optionsPrefix, payload);
}
